import { Col, Form, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"

export default function PreguntaOpcionMultipleV2({item, onHandleMultipleAnswer}){
    const { t } = useTranslation()
    return(
        <>
        <div>
            <label className="colorLabel">{item.title}</label>
            <small className="colorLabel">{t('seleccionar_todas_correspondan')}</small> 
        </div>
        <Row>
            {
                item.options.map((it,i)=>(
                    <Col key={i} xs="12" md="6">
                        <div className="item-encuenta-1 shadow-sm p-3 mb-2">
                            <Form.Check
                                className="colorLabel fw-medium"
                                type="checkbox"
                                value={it}
                                label={it}                               
                                onClick={e=>{
                                    onHandleMultipleAnswer(e.target.value, e.target.checked, item)
                                }}
                            />
                        </div>
                    </Col>
                ))
            }
        </Row>
        </>
    )
}